export  default {
    getTickets(state) {
        return state.tickets;
    },
    getTicketTypes(state) {
        return state.ticketTypes;
    },
    getTicketStatuses(state) {
        return state.ticketStatuses;
    },
    getTicketNotes(state) {
        return state.ticketNotes;
    },

};